import axiosInstance from "../../utils/axiosInterceptor";
import { reducersActions } from "./new-actions";

const {
  FETCH_CAMPAIGNS_REQUEST,
  FETCH_CAMPAIGNS_SUCCESS,
  FETCH_CAMPAIGNS_FAILURE,
} = reducersActions;


export const fetchCampaigns = (page = 1, limit = 10, search) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CAMPAIGNS_REQUEST });
    const params = { page, limit };

    if (search) {
      params.search = search;
    }
    
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL_VMS}/api/v3/campaigns`,
        {
          params
        }
      );

      dispatch({
        type: FETCH_CAMPAIGNS_SUCCESS,
        payload: {
          data: response.data.data,
          page: response.data.page,
          totalPages: response.data.totalPages,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_CAMPAIGNS_FAILURE,
        payload: error.response?.data?.message || 'Something went wrong',
      });
    }
  };
};
